<div class="p-md-5 p-3" id="artists">
  <div class="header">
    <h2 class="text-uppercase">(The artists)</h2>
    <p>Select an artist to explore their works</p>
  </div>

  <div class="row">
    <div class="col-md-8 col-12">
      <div class="d-flex justify-content-between p-3 border-bottom border-1 position-relative artist"
        *ngFor="let artist of artists, index as i">
        <div class="d-flex gap-5">
          <span class="change-color">({{i+1 | number: '2.0-0'}})</span>
          <span class="text-uppercase change-color">{{ artist.name }}</span>
        </div>

        <span class="quantity text-center">{{ artist.quantity | number: '2.0-0' }}</span>
        <img src="/assets/img/open-btn.svg" alt="Open artist" class="open-button">
      </div>
    </div>
  </div>
</div>